import Vue from "vue"
import Vuex, { Store } from "vuex"
import activeSessions, { ActiveSessionsState } from "./modules/active-sessions/active-sessions"
import livestream, { LivestreamState } from "./modules/livestream/livestream"
import currentUser, { CurrentUserState } from "./modules/current-user/current-user"
import testSessions, { TestSessionsState } from "./modules/test-sessions/test-sessions"
import adminUsers, { AdminUsersState } from "./modules/admin-users/admin-users"
import comments, { CommentsState } from "./modules/comments/comments"
import preflights, { PreflightState } from "./modules/preflight/preflight"
import tsHistory, { TsHistoryState } from "./modules/ts-history/ts-history"
import auth, { AuthState } from "./modules/auth/auth"
import organizations, { OrganizationsState } from "./modules/organizations/organizations"

Vue.use(Vuex)

export interface RootState {
  activeSessions: ActiveSessionsState
  livestream: LivestreamState
  currentUser: CurrentUserState
  testSessions: TestSessionsState
  adminUsers: AdminUsersState
  comments: CommentsState
  preflights: PreflightState
  tsHistory: TsHistoryState
  auth: AuthState
  organizations: OrganizationsState
}

const store = new Store<RootState>({
  modules: {
    activeSessions,
    livestream,
    currentUser,
    testSessions,
    adminUsers,
    comments,
    preflights,
    tsHistory,
    auth,
    organizations,
  },
})

export default store
